import dynamic from 'next/dynamic';

import {
  WIDGET_TYPES as TYPES,
  WIDGET_TEMPLATES as TEMPLATES,
} from './constants';
import {
  getPodcastChapterParams,
  toPodcastChapters,
} from './getPodcastChapters';
import { WidgetPlugin } from './types';
import {
  CardCarouselProps,
  CardVariations,
  ContentTypeVariations,
} from '../CardCarousel/types';
import { ContentCardVariant } from '../ContentCard';

export const PodcastBasicPlugin: WidgetPlugin<CardCarouselProps> = {
  type: TYPES.PODCAST,
  template: TEMPLATES.BASIC,
  component: dynamic(() =>
    import('@/components/organisms/CardCarousel').then(mod => mod.CardCarousel),
  ),
  mapProps: widget => {
    const chapterParams = getPodcastChapterParams(widget.template.parameters);
    const chapters = toPodcastChapters(chapterParams);

    return {
      items: chapterParams.map((item, index) => ({
        variant: ContentCardVariant.BASIC,
        title: item.name,
        description: item.description,
        imageUrl: item.image_url,
        id: item.id,
        episodeIndex: index,
        type: CardVariations.BASIC,
        contentType: ContentTypeVariations.PODCAST,
        rawData: {
          id: String(item.podcast_id),
          chapters: chapters,
        },
      })),
      variant: 'default',
      title: widget.title,
      widgetId: widget.id,
      ...(widget.template.configuration?.view_all === true
        ? { showAllURL: `?seeAll&widgetId=${widget.id}` }
        : {}),
    };
  },
};
